export enum UoStatus {
  Draft = "draft",
  Effective = "effective",
  Obsolete = "obsolete"
}

export const uoStatusColors = (uo: string) => {
  switch (uo) {
    case UoStatus.Draft:
      return 'var(--anthracite)';
    case UoStatus.Effective:
      return 'var(--dark-green)';
    case UoStatus.Obsolete:
      return 'var(--dark-red)';
    default:
      return 'var(--primaryColor)';
  }
};

export const uoStatusBackgroundColors = (uo: string) => {
  switch (uo) {
    case UoStatus.Draft:
      return 'var(--light-grey)';
    case UoStatus.Effective:
      return 'var(--light-green)';
    case UoStatus.Obsolete:
      return 'var(--light-red)';
    default:
      return 'var(--primaryColorBcg)';
  }
};